export const KAHVE_LEYLA = [
  {
    id: "kl001",
    metin: "{{ad}}, fincanın bana fısıldıyor. Kahvenin bıraktığı izler tesadüf değil — evrenin sana yazdığı bir mektup. {{soru}} konusunda aradığın cevap, aslında çoktan içinde saklı. Fincanının sol köşesindeki o duman izi bir geçişin habercisi.\n\nEski bir dönem kapanıyor, yenisi sessizce açılıyor. Bu geçişe direnmek yerine ona rehberlik et. 'Ne bırakıyorum, ne alıyorum?' sorusunu sor kendine — cevap yolunu aydınlatacak.",
    tema: "gecis"
  },
  {
    id: "kl002",
    metin: "{{ad}}, ay ve yıldız... fincanında ikisini de görüyorum. Bu nadir bir işaret. {{soru}} sorusunun cevabı gökyüzünde yazılı — sezgilerine güven, çünkü şu an sezgilerin çok güçlü.\n\nBir şeyi hissediyorsan, yanılmıyorsundur. O iç sesi bastıran gürültüyü sustur. Sessizlikte sezgi konuşur — ve sezgi genellikle mantıktan daha hızlı, daha doğru.",
    tema: "sezgi"
  },
  {
    id: "kl003",
    metin: "{{ad}}, fincanın derin bir sessizlikten bahsediyor. {{soru}} için çırpınırken, belki de yapman gereken tek şey durmak.\n\nEvren bazen en güzel hediyelerini sessizlikte verir. Zorlamayı bırak, akışa bırak kendini. Kontrol etmeye çalıştığında elimden kayar — bıraktığında gelir. Bu paradoks, ama gerçek.",
    tema: "akis"
  },
  {
    id: "kl004",
    metin: "{{ad}}, kahvenin bıraktığı bu şekil... bir yılan gibi kıvrılmış, ama tehlike değil bu — dönüşümün simgesi. {{soru}} konusunda sen de bir dönüşüm içindesin.\n\nEski kabuğunu bırakmaya hazır mısın? Çünkü içindeki yeni sen, çıkmak için bekliyor. Dönüşüm acıtır — ama sonunda ortaya çıkan şey, öncesinden çok daha güzel.",
    tema: "donusum"
  },
  {
    id: "kl005",
    metin: "{{ad}}, fincanının ortasında bir boşluk var. Boşluk korkutucu görünür ama aslında olasılıkların evidir. {{soru}} için henüz yazılmamış sayfalar var önünde.\n\nKalemi sen tutuyorsun — ne yazacağını sen seçiyorsun. O boşluğa bakıp üzülme, ona bakıp heyecanlan. Boş sayfa en özgür sayfadır.",
    tema: "olasılık"
  },
  {
    id: "kl006",
    metin: "{{ad}}, fincanın bana su elementi hakkında konuşuyor — duygular, derinlik, akış. {{soru}} konusunda belki çok mantıklı olmaya çalışıyorsun.\n\nAma bu sefer kalbin bilgeliğine kulak ver. Mantık sınır çizer, kalp ufuk açar. İkisi birlikte güçlü — ama bu sefer kalbi öne al, mantığı arkada tut.",
    tema: "duygu"
  },
  {
    id: "kl007",
    metin: "{{ad}}, fincanında bir köprü görüyorum — iki kıyı arasında, sağlam duruyor. {{soru}} konusunda bir köprü kurma vakti.\n\nİki şey arasında, iki insan arasında ya da geçmiş ile gelecek arasında. Geçmekten korkma, köprü sağlam. Karşı kıyı seni bekliyor — ve orası buradan daha güzel.",
    tema: "kopru"
  },
  {
    id: "kl008",
    metin: "{{ad}}, kahvenin kenarında kalan o ince çizgi... kader çizgisi derim buna ben. {{soru}} için şunu söyleyeyim: bazı şeyler tam zamanında gelir — ne erken ne geç.\n\nŞu an zamanlamanın peşinde koşma. Zamanın seni bulmasına izin ver. 'Neden hâlâ olmadı?' yerine 'tam zamanında gelecek' de. O zihin değişikliği beklemeyi daha kolay kılar.",
    tema: "zamanlama"
  },
  {
    id: "kl009",
    metin: "{{ad}}, fincanın ateş enerjisi taşıyor — tutku, güç, yaratıcılık. {{soru}} konusunda o içindeki ateşi söndürme.\n\nBelki yoruldun, belki hayal kırıklığı yaşadın. Ama o alev hâlâ yanıyor. Üfle, körükle, yeniden tutuşsun. Ateşini kaybeden insan yönünü kaybeder — ateşini koruyan ise karanlıkta bile yolunu bulur.",
    tema: "tutku"
  },
  {
    id: "kl010",
    metin: "{{ad}}, fincanının dibinde üç nokta yan yana. Üçlü enerji — geçmiş, şimdi, gelecek. {{soru}} için geçmişe takılı kalma, ama ondan öğren.\n\nŞimdiyi yaşa, geleceği koru. Denge içinde ol. Geçmiş bir öğretmen, şimdi bir arena, gelecek bir davet. Hepsini doğru kullan.",
    tema: "denge"
  },
  {
    id: "kl011",
    metin: "{{ad}}, fincanında bir kapı şekli görüyorum. Açık mı kapalı mı? İkisi arasında. {{soru}} konusunda da tam böyle bir eşikte duruyorsun.\n\nİçeri girmek için sadece bir adım lazım. Kapı kendiliğinden açılmaz — elini uzat. Ve şunu bil: kapıdan girmeyi reddeden asla bilemez içeride ne var.",
    tema: "karar"
  },
  {
    id: "kl012",
    metin: "{{ad}}, bu kahve fincanı bana ışık ve gölgeden bahsediyor. Her ikisi de var hayatında şu an. {{soru}} konusunda karanlık tarafına çok odaklanmışsın.\n\nAma bak — gölge ancak ışık varsa oluşur. Işığın nerede olduğunu bul. Gölgeye bakmak yerine ışığa yönel. Enerji nereye giderse, orada büyür.",
    tema: "isik"
  },
  {
    id: "kl013",
    metin: "{{ad}}, fincanında bir sarmal var — içten dışa doğru açılan bir sarmal. Bu büyüme enerjisi. {{soru}} konusunda da büyüyorsun.\n\nAcı veriyor olabilir — ama her büyüme biraz öyle hissettirir. Tohum toprakta çatlarken acı duyuyor mu? Belki. Ama o çatlama olmadan filiz çıkmaz. Kendine karşı nazik ol bu süreçte.",
    tema: "buyume"
  },
  {
    id: "kl014",
    metin: "{{ad}}, fincanın kenarında toplanan kahve, sınır çekme zamanı diyor. {{soru}} için de böyle — bazı ilişkilerde, bazı durumlarda sınır çekmen gerekiyor.\n\nBu bencillik değil, öz saygı. Sınır çizerken kalbini korursun. Sınırsız verilen şeyler değersizleşir — değer vermek için sınır çizmek gerekir.",
    tema: "sinir"
  },
  {
    id: "kl015",
    metin: "{{ad}}, fincanında bir ayna şekli seçiyorum. Evren sana bir şeyi yansıtıyor. {{soru}} konusunda dışarıda aradığın şey, aslında içinde var.\n\nBaşkalarında gördüğün o özelliği kendin de taşıyorsun. Aynaya bak — gerçekten bak. Kendi gözlerinle gördüğünde, dışarıda aramanın gerekmediğini anlarsın.",
    tema: "yansima"
  },
  {
    id: "kl016",
    metin: "{{ad}}, fincanın hava elementi taşıyor — düşünce, iletişim, hareket. {{soru}} için söylemek isteyip de söyleyemediğin bir şey var.\n\nO sözü içinde tutma. Doğru anda, doğru kişiye söyle. Sessizlik bazen yük olur — ve o yük her ikisini de ağır bastırır. Söylenmesi gereken şeyler sonunda mutlaka söylenir — erken söylemek daha az acıtır.",
    tema: "iletisim"
  },
  {
    id: "kl017",
    metin: "{{ad}}, fincanında bir yıldız parıltısı var — umudun simgesi. {{soru}} konusunda umudunu kaybetme.\n\nKaranlığın en koyu olduğu an, şafak en yakın olduğu andır. Yakında bir ışık göreceksin. O ışık dışarıdan gelmeyebilir — içinden doğacak. Onu bekle.",
    tema: "umut"
  },
  {
    id: "kl018",
    metin: "{{ad}}, fincanın toprak enerjisi veriyor — köklere dönme, sağlamlaşma. {{soru}} için uçmaktan önce köklenmen gerekiyor.\n\nTemelin ne kadar sağlam? Bunu sorgula. Sağlam köklere sahip ağaç, her fırtınaya dayanır. Yukarı gitmek istiyorsan, önce aşağıya in — kökleri derinleştir.",
    tema: "kok"
  },
  {
    id: "kl019",
    metin: "{{ad}}, fincanında iki yol ayrımı görüyorum. Her ikisi de gerçek, her ikisi de senin. {{soru}} konusunda doğru seçim diye bir şey yok aslında — senin için doğru olan seçim var.\n\nİçinden gelen sesi dinle, o sesi bastırma. Mantık iki yolu da değerlendirebilir. Ama hangi yol sana daha çok 'evet' hissettiriyor? O yol senin yolun.",
    tema: "secim"
  },
  {
    id: "kl020",
    metin: "{{ad}}, fincanının üst kısmı çok yoğun kahve bırakmış. Aktif bir zihin bu — belki çok düşünüyorsun. {{soru}} konusunda aşırı analiz tuzağına düşme.\n\nBazen en doğru cevap, düşünmekten değil hissetmekten gelir. Zihni sustur, bedeni dinle. Bedenin cevabı bilir — gerilim mi, rahatlama mı? O his yönünü gösterir.",
    tema: "zihin"
  },
  {
    id: "kl021",
    metin: "{{ad}}, fincanında bir çiçek açılıyor — yavaş yavaş, yaprak yaprak. {{soru}} konusunda da sabır gerekiyor.\n\nBu çiçeği zorla açamazsın. Güneşi, suyu, toprağı ver; zamanı gelince açacak. Sen sadece koşulları hazırla — ve güven. Doğa hiçbir zaman acele etmez, ama hiçbir zaman gecikmez de.",
    tema: "sabir"
  },
  {
    id: "kl022",
    metin: "{{ad}}, fincanın bana bir kayıptan söz ediyor. Ama her kayıp bir boşluk yaratır, her boşluk yeni bir şeyle dolar. {{soru}} konusunda kaybettiğin şeyin ardından yas tut — bu gerekli.\n\nAma orada kalma. Yas bir geçiş ritüelidir — tamamlandığında biter. Gözlerini aç, yeni olan seni bekliyor. Boşluk bir ceza değil, bir davet.",
    tema: "kayip"
  },
  {
    id: "kl023",
    metin: "{{ad}}, fincanında dalgalı bir çizgi var. Hayat hep düz gitmez — iniş çıkış kaçınılmaz. {{soru}} için şunu söyleyeyim: şu an bir iniş dönemindeysen bile, grafik yukarı dönecek.\n\nDalgalar geçici, sen kalıcısın. Her dalga bir öncekinden bir şeyler öğretir. O öğrenmeyi al, ilerle. Dalganın seni götürmesine izin verme — sörf yap üzerinde.",
    tema: "dalgalanma"
  },
  {
    id: "kl024",
    metin: "{{ad}}, fincanının içinde bir ışın demeti seçiyorum. Bu bir buluşmanın, bir birleşmenin işareti. {{soru}} konusunda yalnız yürümek zorunda değilsin.\n\nBirinin eli uzanacak sana — al o eli, yükü paylaş. Yardım istemek zayıflık değil, bağlantı kurmaktır. Ve bağlantı, insanı güçlü kılan şeylerin başında gelir.",
    tema: "birlesme"
  },
  {
    id: "kl025",
    metin: "{{ad}}, sincan bana şunu fısıldıyor: sen sandığından çok daha güçlüsün. {{soru}} seni yıpratmış olabilir, ama yıkmamış.\n\nVe yıkamayacak da. Çünkü içinde, henüz keşfetmediğin bir güç var. Zamanı gelince o güç ortaya çıkacak. O güce güven — o güç her zaman senin için orada.",
    tema: "guc"
  }
];